import { Typography, TypographyProps } from "@mui/material";
import { useEffect, useState } from "react";
import { formatCompactDuration } from "../utils";

interface LiveDurationProps extends Omit<TypographyProps, "children"> {
    startTime: string;
}

export const LiveDuration = ({
    startTime,
    ...typographyProps
}: LiveDurationProps) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, []);

    const start = new Date(startTime);
    const end = new Date(Math.max(now, start.getTime()));
    const label = formatCompactDuration(start, end);

    return <Typography {...typographyProps}>{label}</Typography>;
};
